var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":"","pa-5":""}},[(_vm.moduleIsReady)?_c('div',[_c('SensorPage')],1):_c('div',[_vm._v("Loading profile...")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }